var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"widget-handler"},[(_vm.widgetName=='text')?_c('TextWidget',{attrs:{"element":_vm.element,"config":_vm.config}}):_vm._e(),(_vm.widgetName=='image')?_c('ImageWidget',{attrs:{"config":_vm.config}}):_vm._e(),(_vm.widgetName=='qr')?_c('QrWidget',{attrs:{"config":_vm.config}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }